<div class="d-flex justify-content-center">
    <div class="row content">
        <div class="">
            <label>{{ "welcomePackage.findEquipmentByLabel" | cxTranslate }}</label>
            <div class="search-dropdown">
                <ng-select
                  name="findEquipmentBy"
                  [(ngModel)]="findEquipmentBy"
                  (change)="loadData()"
                  placeholder='{{ "welcomePackage.selectPlaceholder" | cxTranslate }}'
                  [searchable]="false"
                  [clearable]="false"
                >
                  <ng-option *ngFor="let option of findEquipmentByOptions" hidden disabled selected value="{{ option.value }}">
                    <span  *ngIf="option.label == 'Serial Number'">{{ "welcomePackage.serialNumOption" | cxTranslate }}</span>
                    <!-- <span *ngIf="option.label == 'Purchase Order Number'">{{ "welcomePackage.poNumOption" | cxTranslate }}</span>
                    <span *ngIf="option.label == 'Sales Order Number'">{{ "welcomePackage.soNumOption" | cxTranslate }}</span> -->
                  </ng-option>
                </ng-select>
            </div>
          </div>
    
    <div class="arrow-img">
        <img class="img" src="../../../../../assets/img/arrow-downward.svg">
    </div>
    <div class="">
        <label *ngIf="findEquipmentBy == 'SERIAL_NO'" class="add-search">{{ "welcomePackage.serialNoHeader" | cxTranslate }}</label>
        <label *ngIf="findEquipmentBy == 'PO_NO'" class="add-search">{{ "welcomePackage.purchaseOrderNumber" | cxTranslate }}</label>
        <label *ngIf="findEquipmentBy == 'SALES_ORDER_NO'" class="add-search">{{ "welcomePackage.salesOrderNumber" | cxTranslate }}</label>
            <div class="search-input">
                <input type="text" class="form-control" (keyup)="keyUp(search, $event)"   placeholder='{{ "welcomePackage.minChar" | cxTranslate }}' 
                [(ngModel)]="term" #search name="search">
                
            </div> 
    </div>
    <div class="search-button">
        <button class="vs-primary-btn sample-btn" (click) = "modelChange(search)" (keyup)="keyUp(search, $event)">
            <span>{{ "welcomePackage.searchButton" | cxTranslate }}</span>
        </button>
    </div>
</div>
</div>

    <div *ngIf="dataSource$|async as dataSource else loading">
        <vs-search-result *ngIf="showTable && !noBoMData" [dataSource]="dataSource"></vs-search-result>   
    </div> 


<div *ngIf="noData" class="not-found">
    <div class="noData">
        <div class="not-found-content">
            <img class="img" src="../../../../../assets/img/empty-box.svg">
            <h2 class="heading">{{ "welcomePackage.noResultfoundHeading" | cxTranslate }}</h2>
            <p class="text">{{ "welcomePackage.noResultfoundMsg" | cxTranslate : { searchInput: notFound } }}</p>
        </div>
    </div>
</div>
<div *ngIf="noBoMData" class="not-found">
  <div class="noData">
    <div class="not-found-content">
    <img class="img" src="../../../../../assets/icons/Could not complete.svg">
     <h2 class="heading">{{ "welcomePackage.noBOMResultfoundHeading" | cxTranslate }}</h2>
     <p class="text">{{ "welcomePackage.searchClickParagraph" | cxTranslate }}</p>
  </div>
  </div>
</div>
  <ng-template #loading>
    <div class="cx-spinner" *ngIf="showSpinner">
      <cx-spinner></cx-spinner>
    </div>
  </ng-template>